module.exports = __webpack_public_path__ + "img/gongxi.d617d22d.png";